module.exports = __webpack_public_path__ + "static/73gde-1b08f1be9586085936e19190af505779.gif";